import { Navigate, Route, Routes } from 'react-router-dom'
import { Filter } from '../Modules/Filter/Filter'
import { GrafoPage } from '../Modules/GrafoPage/GrafoPage'
import { Home } from '../Modules/home/home'
export const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/grafo" element={<GrafoPage />} />
      <Route path="/filters" element={<Filter />} />
      <Route path="/*" element={<Navigate to="/" />} />
    </Routes>
  )
}
